import { useRouteAssets } from "../../../../hooks/useRouteAssets";
import {
  useGetWalletPoolsQuery,
  useSimulateAddLiquidityQuery,
} from "../../../../store/api/dexApiSlice";
import { useContext, useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { Coins } from "ton3-core";
import { useDebounce } from "../../../../hooks/useDebounce";
import {
  BlockToolTip,
  ClickMaxAmount,
  ClickMaxAmountInner,
  ContentToolTip,
  SwapChoose,
  SwapChooseDefault,
  SwapContainer,
  SwapContent,
  SwapDetail,
  SwapDetailBlock,
  SwapDetailRow,
  SwapExchangeIcon,
  SwapExtension,
  SwapHeader,
  SwapInput,
  SwapInputAsset,
  SwapInputTitle,
  SwapInputWrapper,
  SwapWrapper,
} from "../../Swap/styled";
import TitleCommon from "../../../../components/Common/Title";
import InputCommon from "../../../../components/Common/Input";
import { fieldNormalizer } from "../../../../utils/fieldNormalizer";
import { ButtonCommon } from "../../../../Layout/styled";
import ModalOverlay from "../../../../components/Common/ModalOverlay";
import ChooseToken from "../../Swap/ChooseToken";
import SettingSwap from "../../Swap/Setting";
import { TextResult } from "../../Swap/ChooseToken/styled";
import default_token_image from "../../../assets/Dashboard/Common/default-token-image.png";
import { LiquidityBg, LiquidityHeader, SeparateBlock } from "./styled";
import ConfirmAddLiquidity from "./Confirm";
import { useBalance } from "../../../../hooks/useBalance";
import Loading from "../../../../components/Loading";
import doc_light from "../../../../assets/Dashboard/Swap/doc_light.svg";
import settings_light from "../../../../assets/Dashboard/Swap/settings_light.svg";
import settings_active from "../../../../assets/Dashboard/Swap/settings_active.svg";
import doc_active from "../../../../assets/Dashboard/Swap/doc_active.svg";
import {
  convertFixed,
  toFixedWithoutRounding,
} from "../../../../utils/convertFormatNumber";
import Big from "big.js";
import doc from "../../../../assets/Dashboard/Swap/doc.svg";
import settings from "../../../../assets/Dashboard/Swap/settings.svg";
import { ContextProviderWrapper } from "../../../../components/Context";
import { Loader } from "../../../../components/Loader";
import { useSelector } from "react-redux";
import FormAddLp from "./formAddv1";

export type SwapAction = "offer" | "ask";
const INPUT_DEBOUNCE = 1000;

const AddLiquidity = () => {
  const { isMobile, theme } = useContext(ContextProviderWrapper)!;
  const [switchState, setSwitchState] = useState(false);
  const [active, setActive] = useState(1);

  const handleSwitchTabs = () => {
    switch (active) {
      case 1:
        return <FormAddLp></FormAddLp>;
      case 2:
        return (
          // <SettingSwap
          //   slippageTolerance={slippageTolerance}
          //   setSlippageTolerance={setSlippageTolerance}
          //   setActiveFilter={setActiveFilter}
          //   setSwitchState={setSwitchState}
          //   switchState={switchState}
          // />
          <></>
        );
      default:
        break;
    }
  };
  const listExtensions = [
    {
      id: 1,
      icon: theme === "light" ? doc_light : doc_active,
      activeIcon: doc,
    },
    {
      id: 2,
      icon: theme === "light" ? settings_light : settings,
      activeIcon: settings_active,
    },
  ];
  return (
    <LiquidityBg>
      <SwapContainer id="add-liquidity">
        <LiquidityHeader className={theme}>
          <h2>liquidity pool</h2>
          <p>Earn rewards by providing liquidity</p>
        </LiquidityHeader>
        {false ? (
          <>
            <SwapWrapper>
              <SwapHeader>
                <TitleCommon text={"PROVIDE LIQUIDITY"} />
              </SwapHeader>
              <Loader />
            </SwapWrapper>
          </>
        ) : (
          <>
            <SwapWrapper className={theme}>
              <SwapHeader>
                <TitleCommon text={"PROVIDE LIQUIDITY"} />
                <SwapExtension className={theme}>
                  {listExtensions.map((item, index) => {
                    return (
                      <li
                        onClick={() => {
                          setActive(item.id);
                        }}
                        key={index}
                      >
                        <img
                          src={active === item.id ? item.icon : item.activeIcon}
                          alt="icon"
                        />
                      </li>
                    );
                  })}
                </SwapExtension>
              </SwapHeader>
              {handleSwitchTabs()}
            </SwapWrapper>
          </>
        )}
      </SwapContainer>

      {/* <ModalOverlay
        component={
          <ChooseToken
            isFromModal={true}
            otherCurrentAssetKey={token0Address}
            setCurrentAsset={setToken1Address}
            setOpenFromModal={setOpen1Modal}
            // set Amount
            setAmountFrom={setToken0Amount}
            setAmountTo={setToken1Amount}
            // Check add liq
            isLiq={true}
            isModal={2}
            // favorite
            setListFavorite={setListFavorite}
            listFavorite={listFavorite}
            // setCheckingToken={<></>}
          />
        }
        open={open1Modal}
        setOpen={setOpen1Modal}
        title={"Select a token"}
        width="400px"
      /> */}
      {/* <ModalOverlay
        component={
          <ConfirmAddLiquidity
            token0Amount={token0Amount}
            token1Amount={token1Amount}
            asset0={asset0}
            asset1={asset1}
            minExpectedTokens={minExpectedTokens}
            expectedTokens={expectedTokens}
            estimatedShare={share}
            slippageTolerance={slippageTolerance}
            simulateData={simulateData}
            pool={pool}
            setOpenConfirmModal={setOpenConfirmModal}
            openConfirmModal={openConfirmModal}
          />
        }
        open={openConfirmModal}
        setOpen={setOpenConfirmModal}
        title={" Confirm Add Liquidity"}
        width="500px"
      /> */}
    </LiquidityBg>
  );
};

export default AddLiquidity;

//
